import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["bids"]

  toggle(event) {
    event.preventDefault()
    this.bidsTarget.classList.toggle(this.hiddenClass)
  }
}
